import type { ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import useMediaQuery from "@mui/material/useMediaQuery";

import { WITHHELD_TIPS } from "./Withheld";
import type { WithheldTip } from "./Withheld";
import "./Withheld.scss";

interface LockedControlProps {
  label: string;
  icon?: ReactNode;
  size?: "md" | "sm";
  /** Still locked; lets the page count the attempt (locked_element_clicked). */
  onClick?: () => void;
  /** Prototype lockedCtl with a tip: hovering says what it is and when it unlocks (same tip as the Hidden chip). */
  tip?: WithheldTip;
}

function LockedControl({ label, icon = null, size = "md", onClick, tip }: LockedControlProps) {
  // PRD-3966: on phones the tip opens below, so it doesn't cover the name above the buttons
  const isPhone = useMediaQuery("(max-width: 767px)");
  const control = (
    <span
      className={`locked-control locked-control--${size}${tip ? " locked-control--tip" : ""}`}
      aria-disabled="true"
      onClick={onClick}
      role="presentation"
    >
      {icon}
      {label}
      <span className="locked-control__tag">Locked</span>
    </span>
  );
  if (!tip) return control;
  const [title, text] = WITHHELD_TIPS[tip];
  return (
    <Tooltip
      title={
        <>
          <b>{title}</b>
          {text}
        </>
      }
      // Prototype .p-actions .locked-tip .tip: above, lined up with the control's right edge
      placement={isPhone ? "bottom-end" : "top-end"}
      enterTouchDelay={0}
      leaveTouchDelay={4000}
      slotProps={{ tooltip: { className: "hidden-chip-tip" } }}
    >
      {control}
    </Tooltip>
  );
}

export default LockedControl;
